interface options {
  first?: number;
  offset?: number;
}
export class ListUtil<T> {
  public data: ({ id: string } & T)[] = [];
  public totalCount = 0;
  constructor(data: T[]) {
    if (data && data.length > 0) {
      this.data = data.map((datum: T, index: number) => {
        return {
          ...datum,
          // FIXME:: Add handling in typescript to honour the id
          // @ts-ignore
          id: datum?.id?.toString() || index.toString(),
        };
      });
      this.totalCount = this.data.length;
    }
  }
  get(options?: options): T[] {
    if (!options) {
      return this.data;
    }
    const { first, offset } = options;
    if (Number.isFinite(first) && Number.isFinite(offset)) {
      // @ts-ignore
      return this.data.slice(offset, offset + first + 1);
    }
    return this.data;
  }
}
